import { IonButton, IonCol, IonContent, IonIcon, IonPage, IonRow, IonText, IonInput } from "@ionic/react"
import Foot from "../../Footer"
import Head from "../../Header"
import moment, { months } from "moment";
import Sidebar from "../../Sidebar"
import DataTable from "react-data-table-component";
import { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router";
import service from "../../../Service/service";
import { useLocation } from 'react-router-dom';

import swal from 'sweetalert';
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { add } from "ionicons/icons";
import "../../../theme/style2.css"
import MemberTimeSheet from "../../Team Member/MyTImesheet";

const HRViewTimesheetHistory: React.FC = (props) => {
    // const history = useHistory();
    const history = useHistory();

    const [timesheetId, setTimesheetId] = useState("");
    //const { state } = props.location

    // const View = (id: any) => {
    //     console.log(id, "g")
    //     history.push({ pathname: "/HRViewTimesheetHistory", state: { Id: id } })
    // }


    /*..................Create TimeSheet.............. */

    const [loglist, setloglist]: any = useState([]);
    loglist.forEach((item: any, index: any) => { item.serial = index + 1; });
    const [data, setdata] = useState([])
    const [selectedOption, setSelectedOption] = useState("");
    const [Id] = useState(localStorage.getItem("SignupEmpId"));
    //const [id,setid]=useState("");
    const [month, setmonth] = useState("")
    const [modalopen, setModalopen] = useState(false);
    const [filterText, setFilterText] = useState("");
    const location: any = useLocation();
    /*..................View Time Sheet.............. */
    const [fDate, setFDate] = useState("");
    const [tDate, setTDate] = useState("");
    const [status, setStatus] = useState("");
    const [hours, setHours] = useState("");
    const [respondedBy, setRespondedBy] = useState("");
    const [description, setdescription] = useState("");
    const [feedback, setFeedback] = useState("");
    const [timeloglist, setTimeloglist] = useState([]);
    const [viewMonth, setViewMonth] = useState("");
    const [viewWeek, setViewWeek] = useState("");
    const id = (location.state?.Id);
    //const menuSelected = location.state.menuSelect;
    const handleSelectChange = (e: any) => {
        if (e.target.value === "all") {
            setSelectedOption(e.target.value);
            setmonth('')
        }
        else {
            setSelectedOption(e.target.value);
        }
        console.log(e.target.value, "kmk")
    };
    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    timeloglist.forEach((item: any, index: any) => { item.serial = index + 1; });
    const closemodal = () => {
        setModalopen(false);
        setStatus("");
        setFDate("");
        setTDate("");
        setHours("");
        setdescription("");
        setFeedback("");
        setRespondedBy("");
        setTimeloglist([]);
        setTimesheetId("");
    }
    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px",
                padding: "0px",
                justifyContent: "center"
            },
        },
        row: {
            style: {
            }
        },
        cells: {
            style: {
                fontSize: "16px",
                justifyContent: "center",
                padding: "0px"
            }
        }
    };
    useEffect(() => {
        if (Id === null) {
            history.push("/login");
        } else {
        }
    }, [Id, history]);
    const Teamsheetremove = () => {
        console.log(month, "kmkk")
        service.Timesheethistory(id, month)
            .then((response) => {
                console.log(id)
                console.log(response.data);
                if (response.data.Status === "200") {
                    setdata(response.data.Data)
                    //   setmonth(month)
                }
                else {
                    swal("", "No TimeSheet Present", "error")
                }
            })
    }
    const ViewTimesheet = (id: any) => {
        setModalopen(true);
        service.ViewEmployeeTimeSheetById(id)
            .then((response) => {
                console.log(response.data, "ionr");
                setTimesheetId(response.data.Data.id);
                setStatus(response.data.Data.status?.status ?? "N/A");
                setFDate(response.data.Data.fromDate);
                setTDate(response.data.Data.toDate);
                setHours(response.data.Data.totalhours);
                setdescription(response.data.Data.description);
                setFeedback(response.data.Data.feedback);
                setRespondedBy(response.data.Data.respondedBy);
                if (response.data.Data.timeSheetLog != null || response.data.Data.timeSheetLog != "") {
                    setTimeloglist(response.data.Data.timeSheetLog);
                }
                else {
                    setTimeloglist([]);
                }
                setViewMonth(response.data.Data.month);
                setViewWeek(response.data.Data.week);
            })
    }
    const ViewColumns: any = [
        {
            name: "S.No",
            width: "50px",
            selector: (itm: any, i: any) => i + 1,
            sortable: false,
        },
        {
            name: "Date",
            selector: (itm: any) => moment(itm.date).format("DD-MM-YYYY"),
            sortable: true,
        },
        {
            name: "Project",
            sortable: true,
            widtth: "100px",
            selector: (itm: any) => itm.project.projectName,
        },
        {
            name: "Activity",
            sortable: true,
            width: "150px",
            selector: (itm: any) => itm.activity,
        },
        {
            name: "Activity Description",
            sortable: true,
            width: "200px",
            selector: (itm: any) => itm.workdescription,
        },
        {
            name: "Effort",
            sortable: true,
            width: "100px",
            selector: (itm: any) => `${itm.hours}:${itm.minutes}`,
        },
        // {
        //     name: "Effort",
        //     sortable: true,
        //     width: "100px",
        //     selector: (itm: any) => itm.timeLogList[0].hours + "." + itm.timeLogList[0].minutes,
        // },
    ];

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => i + 1,
            sortable: false,
            width: "100px"
        },
        {
            name: "Week",
            selector: (itm: any) => itm.description,
            sortable: true,
            width: "320px"
        },
        {
            name: "Weekly Effort",
            selector: (itm: any) => itm.totalhours,
            sortable: true,
            width: "120px"
        },
        {
            name: "Create On",
            sortable: true,
            selector: (item: any) => moment(item.requestedDate).format("DD-MM-YYYY"),
        },
        {
            name: "Status",
            sortable: true,
            cell: (itm: any) => (
                <>
                    {itm.status !== null ? (
                        <IonText
                            className={
                                itm.status.status === "Approved"
                                    ? "color_approve"
                                    : itm.status.status === "Open"
                                        ? "color_progress"
                                        : "color_deny"
                            }
                        >
                            {itm.status.status}
                        </IonText>
                    ) : (
                        <IonText className="color_deny">N/A</IonText>
                    )}
                </>
            )
        },
        {
            name: "Approved By",
            selector: (itm: any) => itm.respondedBy,
            sortable: true,
            cell: (itm: any) => {
                var na = itm.respondedBy;
                var na1;
                if (na === null || na === "") {
                    na1 = "PENDING";
                }
                else {
                    na1 = na;
                }
                return (
                    <>
                        <IonText>{na1}</IonText>
                    </>
                )
            }
        },
        {
            name: " Action",
            sortable: false,
            width: "120px",
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral", paddingLeft: "15px" }}>
                        <IonText onClick={() => ViewTimesheet(itm.id)} style={{ color: "coral", cursor: 'pointer' }} >View</IonText>
                    </div>
                </>
            )
        }
    ];
    const tabledata = Array.isArray(data) ? data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    ) : [];
    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col">
                                <h3 className="page-title" style={{ fontWeight: "bold" }}> View Employee Timesheet History </h3>
                            </div>
                        </div>
                    </div>
                    {/*................View TimeSheet........... */}
                    <Modal
                        dialogClassName="my-modal modal-dialog-centered"
                        id="logouts-modal"
                        show={modalopen}
                    >
                        <div className="modal-header">
                            <h5 className="modal-title">View Time Sheet</h5>
                            <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-lg-4 col-md-6">
                                        <div className="form-group" >
                                            <label style={{ fontWeight: "bold" }}>Month </label>
                                            <div>
                                                <IonInput value={viewMonth} readonly type="month" className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Week </label>
                                            <div>
                                                <IonInput value={viewWeek} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Status </label>
                                            <div>
                                                <IonInput value={status} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Hours </label>
                                            <div>
                                                <IonInput value={hours} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Responded By </label>
                                            <div>
                                                <IonInput value={respondedBy} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Description </label>
                                            <div>
                                                <IonInput value={description} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Feedback </label>
                                            <div>
                                                <IonInput value={feedback} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="table-responsive" style={{ marginTop: "1%" }}>
                                <label style={{ fontWeight: "bold" }}>Time Log</label>
                                <DataTable
                                    columns={ViewColumns}
                                    data={timeloglist}
                                    // noDataComponent="Data not found !"
                                    pagination
                                    paginationPerPage={3}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[3, 6, 9, 12]}
                                    customStyles={customStyles}
                                />
                            </div>
                            <div className="row">
                                {/* {renderResubmitButton(status)} */}
                                <div className="col">
                                    <div className="submit-section">
                                        <button
                                            type="button"
                                            className="btn-primary submit-btn"
                                            onClick={closemodal}
                                        >
                                            Back
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>

                    <div>
                        <form className="row addmore">
                            <div className="col-sm-6 col-md-4" style={{ marginTop: "1rem" }}>
                                <label style={{ fontWeight: "bold" }}>Timesheet</label>
                                <div>
                                    <select className="select" value={selectedOption} onChange={handleSelectChange}>
                                        <option value="" disabled selected>Select</option>

                                        <option value="choosemonth">Choose Month</option>
                                        <option value="all">All</option>
                                    </select>
                                </div>
                            </div>
                            {selectedOption === "choosemonth" && (
                                <div className="col-sm-6 col-md-4" style={{ marginTop: "1rem" }}>
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Month & Year</label>
                                        <div>
                                            <IonInput type="month" className="form-control datetimepicker" onIonChange={(e: any) => setmonth(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="form-group col-md-3" style={{ marginTop: "1rem" }} >
                                <label><span className="text-danger"></span></label>
                                <div>
                                    <button type="button" className="btn btn-primary submit-btn" onClick={() => Teamsheetremove()}>Search</button>
                                </div>
                            </div>

                        </form>
                    </div>
                    {/* {selectedOption !== "" && ( */}
                    <div className="table-responsive" style={{ marginTop: "1%" }}>
                        <DataTable
                            columns={columns}
                            data={data}
                            pagination
                            paginationPerPage={10}
                            paginationComponentOptions={paginationComponentOptions}
                            paginationRowsPerPageOptions={[10, 20, 30]}
                            customStyles={customStyles}
                        />
                    </div>
                    {/* )} */}
                </div>
            </IonContent>
        </IonPage>
    )
}

export default HRViewTimesheetHistory